import Decimal from 'decimal.js-light'

const isUndefinedOrNan = (a?: number | null, b?: number | null): boolean =>
  a === undefined || b === undefined || Number.isNaN(a) || Number.isNaN(b)

const isInfinity = (a?: number | null, b?: number | null): boolean =>
  a === Infinity || b === Infinity

export const add = (a: number, b: number) => {
  if (isUndefinedOrNan(a, b)) {
    return NaN
  }

  if (isInfinity(a, b)) {
    return Infinity
  }

  return new Decimal(a || 0)
    .add(b || 0)
    .toDecimalPlaces(2)
    .toNumber()
}

export const sub = (a: number, b: number) => {
  if (isUndefinedOrNan(a, b)) {
    return NaN
  }

  if (isInfinity(a, b)) {
    return Infinity
  }

  return new Decimal(a || 0)
    .sub(b || 0)
    .toDecimalPlaces(2)
    .toNumber()
}

export const mul = (a: number, b: number) => {
  if (isUndefinedOrNan(a, b)) {
    return NaN
  }

  if (isInfinity(a, b)) {
    return Infinity
  }

  return new Decimal(a || 0)
    .mul(b || 0)
    .toDecimalPlaces(2)
    .toNumber()
}

export const div = (a: number, b: number) => {
  if (isUndefinedOrNan(a, b)) {
    return NaN
  }

  if (isInfinity(a, b)) {
    return Infinity
  }

  return new Decimal(a || 0)
    .div(b || 0)
    .toDecimalPlaces(2)
    .toNumber()
}

export const round2 = (a?: number | null) => {
  if (a === undefined || a === null || Number.isNaN(a)) {
    return NaN
  }

  if (a === Infinity) {
    return Infinity
  }

  return new Decimal(a).toDecimalPlaces(2).toNumber()
}

export const sum = (numbers: number[]) => {
  if (!numbers || numbers.length === 0) {
    return 0
  }

  if (numbers.some((n) => Number.isNaN(n))) {
    return NaN
  }

  if (numbers.some((n) => n === Infinity)) {
    return Infinity
  }

  return numbers
    .reduce((acc, curr) => new Decimal(acc).add(curr || 0), new Decimal(0))
    .toDecimalPlaces(2)
    .toNumber()
}
